/**
 * Created by mac90082 on 10/26/16.
 */
import { WindowToken } from "@app/util/window.token";
import { Component, Inject } from "@angular/core";
import { UserStore } from "@app/services/stores/UserStore";

@Component({
    selector: 'app-faq',
    template: require('./faq.html')
})
export class FAQComponent {
    private oneTimePayment: boolean;
    private managingProperties: boolean;
    private managingPayments: boolean;
    private managingWallet: boolean;
    private myAccount: boolean;
    private other: boolean;

    constructor(@Inject(WindowToken) public window  , @Inject(UserStore) private userStore: UserStore) {
        this.oneTimePayment = false;
        this.managingProperties = false;
        this.managingPayments = false;
        this.managingWallet = false;
        this.myAccount = false;
        this.other = false;
    }

    openUrl(url) {
        this.window.open(url, '_blank');
    }
}

